const h = (t) => {
  const r = t == null ? void 0 : t.getAttribute("src"), s = t == null ? void 0 : t.getAttribute("alt"), c = t == null ? void 0 : t.getAttribute("title"), n = t == null ? void 0 : t.getAttribute("width"), o = t == null ? void 0 : t.getAttribute("height");
  return {
    src: r,
    alt: s,
    title: c,
    width: n,
    height: o
  };
};
export {
  h as getImageAttrs
};
